<template>

    <div class="containerBox">
        <div class="zxkc_tile">师资力量</div>
        <div class="zxkc_content">
            <div class="zxkc_content_left">
                <div class="zxkc_content_left_item_unactive" :class="index == currentIndex ? 'zxkc_content_left_item_active' : ''"
                    @click="changeTeacher(index)" v-for="(item,index) in team">{{ item.name }}</div>
              
            </div>
            <div class="zxkc_content_center"></div>
            <div class="szll_content" >
                <div class="szll_content_top">
                    <div class="szll_content_top_left" ><img style="height: 100%; width: 100%; object-fit: cover; border-radius: 9px 0px 0px 9px;"
                        :src="getUrl + team[currentIndex].imgUrl" /></div>
                    <div class="szll_content_top_right">
                        <div class="szll_content_top_right_first">
                            <div class="szll_content_top_right_first_left">{{ team[currentIndex].name }}</div>
                            <div class="szll_content_top_right_first_right">{{ team[currentIndex].professionalTitle }}</div>
                        </div>
                        <div class="row_line" style="margin-top: 20px;"></div>
                        <div class="szll_content_top_right_second"> 研究方向：{{ team[currentIndex].researchDirection }}</div>
                        <div class="szll_content_top_right_third">
                            <div class="szll_content_top_right_third_left">
                                <div class="szll_content_top_right_third_left_img"><img src="../../src/images/telephone.png"></div>
                                <div class="szll_content_top_right_third_left_text">{{ team[currentIndex].phone }}</div>
                            </div>
                            <div class="szll_content_top_right_third_left">
                                <div class="szll_content_top_right_third_left_img" style="margin-top: 3px;"><img src="../../src/images/email.png"></div>
                                <div class="szll_content_top_right_third_left_text">{{ team[currentIndex].email }}</div>
                            </div>
                        </div>
                        <div class="szll_content_top_right_fourth">
                            <div class="szll_content_top_right_fourth_left">
                                <div class="szll_content_top_right_third_left_img"><img src="../../src/images/address.png"></div>
                                <div class="szll_content_top_right_third_left_text">{{ team[currentIndex].address }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="szll_content_bottom">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="个人简历" name="first"><div style="color: black; overflow: auto; height: 54vh;"  v-html="team[currentIndex].bio"></div></el-tab-pane>
                        <el-tab-pane label="申请专利" name="second"><div style="color: black; overflow: auto; height: 54vh;"v-html="team[currentIndex].applyForPatent"></div></el-tab-pane>
                        <el-tab-pane label="科研项目" name="third"><div style="color: black; overflow: auto; height: 54vh;"v-html="team[currentIndex].scientificResearchItem"></div></el-tab-pane>
                        <el-tab-pane label="代表性论文" name="fourth"><div style="color: black; overflow: auto; height: 54vh;"v-html="team[currentIndex].representativePapers"></div></el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { url } from '../services/url'

import {
    listTeam
} from "../services/services";
export default {
    name: 'Index',
    data() {
        return {
            userId:localStorage.getItem('userId'),
            team:[],
            currentIndex:0,
            activeName:'first',
            getUrl: url
        }
    },
    created(){
        const loading = this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
        listTeam(this.userId).then(res=>{
            this.team=res.rows
            setTimeout(() => {
                loading.close()  
            }, 500);
            

        }).catch(err=>{
            loading.close()
        })
    },
    methods: {
        changeTeacher(index){
            this.currentIndex=index
        }
    },

}
</script>
<style>
/* 或者本地文件 */
@import url('../css/style.css');
</style>